import Btn from '../utils/btn';

const func = $target => {
	var $removeBtn = $target.find('[data-id="btn-remove"]'),
		total = $target.find('[data-multiadd-total]').data('multiadd-total'),
		$currencyTotal = $target.find('[data-id="currency-total"]');

	$removeBtn.on('click', function(e) {
		e.preventDefault();

		var $this = $(this),
			$qty = $this.parent().find('[data-id="qty"]'),
			$container = $this.parent().find('.card'),
			price = $this.data('price');

		if($qty.val() == 0) {
			$container.css("opacity","");
			$qty.val(1);
			$this.text('Remove');
			// add
			total += price;

		} else {
			$container.css("opacity",".1");
			$qty.val(0);
			$this.text('Select');
			// sub
			total -= price;
		}

		$currencyTotal.text( function(i,txt) {return txt.replace(/[0-9.]+/,total.toFixed(2)); });

	});

};

export default func;